import styled from 'styled-components';

import { theme } from 'coreOld/themes';

export const RequestJobsDetailsWrapper = styled.div`
  min-height: calc(100vh - ${theme.topFixedHeaderHeight}px);
`;
